/* eslint-disable default-param-last */
/**
 * @description Ações relacionadas a definição do state da aplicação
 * @author Bene Lemuel Dantas Gondim
 * @file usuariosReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'
import * as actionTypes from 'actions'

// Estado inicial da sessão no redux
const initialState = {
  usuarios: [],
  centraisCustodiaUsuario: [],
  usuarioNaoEncontrado: false,
  emailErrado: false,
  emailEnviado: false,
  erroToken: false,
  redefinir_senha_sucesso: false,
  solicitar_redefinir_senha_erro: false,
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    nome: '',
    sobrenome: '',
    cpf: '',
    matricula: '',
    email: '',
    setor: '',
    cargo: '',
    administrador: false,
    deletado: false,
  },
}

// Trata as possibilidades de login, se sucesso, define o estado do redux armazenando as informações do usuário
const usuariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USUARIOS: {
      return {
        ...state,
        usuarios: action.usuarios,
      }
    }

    case actionTypes.FETCH_CENTRAIS_CUSTODIA_USUARIO: {
      return {
        ...state,
        centraisCustodiaUsuario: action.centraisCustodiaUsuario,
      }
    }

    case actionTypes.SET_PROCESSANDO_FETCH_USUARIOS: {
      return {
        ...state,
        processandoUsuarios: action.isProcessandoUsuarios,
      }
    }

    case actionTypes.USUARIO_SUCESSO: {
      return {
        ...state,
        nomeFuncao: action.nomeFuncao,
        statusHttp: action.statusHttp,
        editado: action.editado,
        dados: {
          id: action.dados.id,
          nome: action.dados.nome,
          sobrenome: action.dados.sobrenome,
          cpf: action.dados.cpf,
          matricula: action.dados.matricula,
          email: action.dados.email,
          setor: action.dados.setor,
          cargo: action.dados.cargo,
          administrador: action.dados.administrador,
          deletado: action.dados.deletado,
        },
      }
    }

    case actionTypes.USUARIO_ERROR: {
      return {
        ...state,
        error: action.dados,
        statusHttp: action.statusHttp,
        nomeFuncao: action.nomeFuncao,
      }
    }

    case actionTypes.REDEFINIR_SENHA_USUARIO_NAO_ENCONTRADO: {
      return {
        ...state,
        usuarioNaoEncontrado: true,
      }
    }

    case actionTypes.REDEFINIR_SENHA_EMAIL_ERRADO: {
      return {
        ...state,
        emailErrado: true,
      }
    }

    case actionTypes.REDEFINIR_SENHA_EMAIL_ENVIADO: {
      return {
        ...state,
        emailEnviado: true,
      }
    }

    case actionTypes.REDEFINIR_SENHA_ERRO_TOKEN: {
      return {
        ...state,
        erroToken: true,
      }
    }

    case actionTypes.REDEFINIR_SENHA_SUCESSO: {
      return {
        ...state,
        redefinir_senha_sucesso: true,
      }
    }

    case types.SOLICITAR_REDEFINIR_SENHA_ERROR: {
      return {
        ...state,
        solicitar_redefinir_senha_erro: true,
      }
    }

    default: {
      return state
    }
  }
}

export default usuariosReducer
